import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { GetCompanyProductDetailsAction, SetCompanyProductFormDataAction } from "../../../redux/actions/companyAction";
import { useDispatch, useSelector } from "react-redux";

function CompanyProducts({ companyId }) {
    const [loading, setloading] = useState(true);
    const [selectedRow, setselectedRow] = useState([]);
    const dispatch = useDispatch();

    const companyProductDetail = useSelector((state) => state?.companySlice?.companyProductDetails);

    const onRowSelect = (event) => {
        dispatch(SetCompanyProductFormDataAction(event.data));
    };

    const getCompanyProductDetail = async () => {
        await dispatch(GetCompanyProductDetailsAction("zbizgateway/nonFin/getCompanyProduct/" + companyId));
    };

    const statusTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className={rowData.isActive === "Y" ? "p-badge p-badge-success" : "p-badge p-badge-danger"}>{rowData?.isActive === "Y" ? "Active" : "Inactive"}</span>
            </React.Fragment>
        );
    }

    useEffect(() => {
        getCompanyProductDetail();
    }, []); // eslint-disable-line

    useEffect(() => {
        if (companyProductDetail !== []) {
            setloading(false);
        }
    }, [companyProductDetail]);

    return (
        <div>
            <div className="card p-datatable-sm">
                <DataTable selection={selectedRow} onSelectionChange={(e) => setselectedRow(e.value)} selectionMode="single" dataKey="companyProductId" onRowSelect={onRowSelect} loading={loading} paginator rows={5} value={companyProductDetail} emptyMessage="No data found.">
                    <Column filter field="limitPerDay" header="Limit Per Day" />
                    <Column filter field="limitPerMonth" header="Limit Per Month" />
                    <Column filter field="limitPerYear" header="Limit Per Year" />
                    <Column filter field="tblProduct.productName" header="Name" />
                    <Column filter field="tblParserHead.parserName" header="Parser Name" />
                    <Column field="status" filterField={(rowData) => rowData?.isActive === "Y" ? "Active" : "Inactive"} header="Status" body={statusTemplate} filter filterMatchMode="contains" />
                </DataTable>
            </div>
        </div>
    );
}

export default CompanyProducts;
